import { CoherenceDataGrid } from "@coherence-design-system/controls";
import React, { useEffect, useState } from "react";
import * as H from 'history';
import { CustomerAccountService } from "../../services/Accounts/CustomerAccountService";
import { useAppInsightsContext } from "@microsoft/applicationinsights-react-js";
interface IAccountsProps {
    history?: H.History;
};


export const Accounts: React.FunctionComponent<IAccountsProps> = (props) => {

    const [accountsData, setaccountData] = useState([])

    const appInsights = useAppInsightsContext();

    useEffect(() => {
        appInsights.trackTrace({message: "API call started: CustomerAccountService -> GetCustomerAccountsInfo() in Account.tsx"});
        CustomerAccountService.getCustomerAccountsInfo()
            .then(res => {
                if (res !== undefined) {
                    setaccountData(res.data.data);
                }
            })
            .catch(error => {
                console.log('Error in Accounts.tsx' + error);
                appInsights.trackException({error, properties: {name: "In Account.tsx, error while retrieving customer accounts information."}})
            });
            appInsights.trackTrace({message: "API call ended: CustomerAccountService -> GetCustomerAccountsInfo() in Account.tsx"});
    }, []);


    return (
        <div data-testid="account-page"
            style={{
                marginTop: "10px",
                height: 500,
                background: "whitesmoke"
            }}
        >
            <CoherenceDataGrid
                compactMode="compact"
                data={accountsData}
                isScrollable
                isSortable
                listConfig={[
                    {
                        fieldName: 'lastOrderDate',
                        key: 'lastOrderDate',
                        name: 'Last Order Date',
                        type: 'string'
                    },
                    {
                        fieldName: 'billingAccount',
                        key: 'link',
                        name: 'Billing Account',
                        type: 'link',
                        url: 'url'
                    },
                    {
                        fieldName: 'accountOwner',
                        key: 'accountOwner',
                        name: 'Account Owners',
                        type: 'string'
                    },
                    {
                        fieldName: 'authorizedBuyer',
                        key: 'authorizedBuyer',
                        name: 'Athorized Buyers',
                        type: 'string'
                    },
                    {
                        fieldName: 'accountNumber',
                        key: 'accountNumber',
                        name: 'Account Number',
                        type: 'string'
                    },
                    {
                        fieldName: 'soldTo',
                        isResizable: true,
                        key: 'soldTo',
                        name: 'Sold To',
                        type: 'string'
                    }
                ]}
            />
        </div>
    );
}